<!-- 带预览的上传，方块上传按钮，包含所有上传逻辑，最终返回文件ID给父组件 -->
<template>
  <div class="d-flex flex-wrap">
    <template v-if="previewType === 'thumb'">
      <b-link v-for="(item, index) in fileList" :key="index" @click.prevent="previewFiles(fileList, index)" class="me-3 mb-3">
        <div class="position-relative">
          <div class="avatar-md align-self-center border border-dashed rounded">
            <div class="avatar-title bg-white rounded fs-24">
              <img v-if="item.content_type.startsWith('image')" :src="item.url">
              <i v-else class="ri-file-text-line text-info"></i>
            </div>
          </div>
          <i v-if="canDelete" class="position-absolute ri-close-circle-fill cursor-pointer text-danger" style="font-size: 1rem;top:-5px;right: -5px;" @click.prevent="deleteFile(item.id, index)"></i>
        </div>
      </b-link>
    </template>
    <template v-else>
      <div class="border rounded border-dashed p-2 me-3 mb-3" v-for="(item, index) in fileList" :key="index">
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0 me-3">
            <b-link @click.prevent="previewFiles(fileList, index)">
              <div class="avatar-sm">
                <div class="avatar-title bg-light rounded fs-24">
                  <img v-if="item.content_type.startsWith('image')" :src="item.url">
                  <i v-else class="ri-file-text-line text-info"></i>
                </div>
              </div>
            </b-link>
          </div>
          <div class="flex-grow-1 overflow-hidden">
            <h5 class="fs-13 mb-1" style="width: 100px;">
              <b-link class="text-body text-truncate d-block" :href="item.url" target="_blank">{{ item.object_name.split('/').pop() }}</b-link>
            </h5>
            <div>{{ formatFileSize(item.size) }}</div>
          </div>
          <div class="flex-shrink-0 ms-2">
            <div class="d-flex gap-1">
              <b-link class="btn btn-icon text-muted btn-sm fs-18" @click.prevent="downloadFile(item.url, item.content_type)"><i class="ri-download-2-line"></i></b-link>
              <button v-if="canDelete" class="btn btn-icon text-muted btn-sm fs-18" @click="deleteFile(item.id, index)"><i class="ri-delete-bin-6-line"></i></button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <upload-btn v-if="showUploadBtn" :multiple="multiple" :input-id="inputId" @onFileSelected="onFileSelected" :custom-class="previewType == 'card' ? 'upload-btn-h66' : ''"></upload-btn>
    <ImgsViewer ref="fileView" :images="viewImgs" />
  </div>
</template>
<script>
import UploadBtn from "@/views/widgets/upload-files/upload-btn";
import _ from 'lodash'
import {formatFileSize} from "@/helpers/common";
import {downloadFile, getFileDetail} from "@/service";
import {updateFiles} from "@/helpers/common-service";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import ImgsViewer from "@/views/widgets/imgs-viewer";

export default {
  props: {
    // 接收文件ID或对象列表，进行预览
    value: {
      type: [Array, null, undefined],
      default () {
        return []
      }
    },
    // 上传input ID
    inputId: {
      type: String,
      default: 'fileInput'
    },
    // 选择文件时是否可多选
    multiple: {
      type: Boolean,
      default: true,
    },
    // 预览样式: thumb:只显示图片 ，card：显示图片、文件大小、文件名
    previewType: {
      type: String,
      default: 'thumb',
    },
    // 上传的文件前缀定义
    filenamePrefix: {
      type: String,
      default: ''
    },
    // 是否显示上传按钮
    showUploadBtn: {
      type: Boolean,
      default: true
    },
    // 是否可删除文件
    canDelete: {
      type: Boolean,
      default: true
    }
  },
  emits:["changed"],
  data () {
    return {
      fielIds: [],
      fileList: [],
      viewImgs: [],
      currentViewIndex: 0,
    }
  },
  mounted() {

  },
  methods: {
    formatFileSize,
    downloadFile,
    deleteFile(id, index) {
      this.fileList.splice(index, 1)
      _.remove(this.fielIds, o => o == id)
      this.$emit('changed', _.cloneDeep(this.fielIds))
    },
    onFileSelected(files) {
      NProgress.start()
      const jobs = []
      files.forEach(file => {
        jobs.push(updateFiles(file, 'add', this.filenamePrefix))
      })
      Promise.all(jobs).then(results => {
        for (let i = 0; i < results.length; i++) {
          this.fileList.push(results[i])
          this.fielIds.push(results[i].id)
        }
        this.$emit('changed', _.cloneDeep(this.fielIds))
        NProgress.done()
      })
    },
    initFileList(val) {
      const itemList = val ? val : []
      if (!itemList.length) {
        this.fielIds = []
        this.fileList = []
        return
      }
      // value 传的 图片对象
      if (typeof itemList[0] === 'object') {
        this.fielIds = _.map(itemList, 'id')
        this.fileList = itemList
        return;
      }
      // value 传的是图片ID
      this.fielIds = itemList
      this.fileList = []
      this.fielIds.forEach((attach) => {
        let pramas = {
          id__in: attach,
        };
        getFileDetail(pramas).then((res) => {
          if (res && res.payload && res.payload.results) {
            let results = res.payload.results;
            results.forEach((result) => {
              this.fileList.push(result);
            });
          }
        });
      });
    },
    previewFiles(files, index) {
      this.viewImgs = files
      this.$refs.fileView.show(index)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        this.initFileList(val)
      }
    }
  },
  components: {
    UploadBtn,
    ImgsViewer,
  }

}
</script>
<style>
.upload-btn-h66 {
  width: 66px;
  height: 66px;
}
</style>
